import axios from "axios"
import { Dispatch } from "redux"
import {AUTH_URL } from "../constants"
import { LOANS_FAIL, LOANS_REQUEST, LOANS_SUCCESS } from "../constants/loansConstants"


export const fetchLoans = (status: string | null, client: string| null | undefined, branch: string| null | undefined,)=> async(dispatch: Dispatch)=>{
    try {

        dispatch({type: LOANS_REQUEST})

        const {data} = await axios.post(`${AUTH_URL}/finances/loans/fetch`, {status, client, branch}, {withCredentials: true})

        dispatch({type: LOANS_SUCCESS, payload: data})
        
    } catch (error:any) {

        dispatch({type: LOANS_FAIL, payload: error.response && error.response.data.message ? error.response.data.message : error.message})
    }
}